const normalizeText = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const isChatReactionNotification = (notification = {}) => {
  const notificationKind = normalizeText(notification?.tipoNotificacion);
  const message = normalizeText(notification?.mensaje);
  const combinedText = `${notificationKind} ${message}`;

  const referencesReaction =
    combinedText.includes("reaction") || combinedText.includes("reaccion");
  const kindReferencesMessage =
    notificationKind.includes("message") ||
    notificationKind.includes("mensaje") ||
    notificationKind.includes("msj");
  const referencesChatMessage =
    combinedText.includes("chat message") ||
    combinedText.includes("mensaje de chat") ||
    combinedText.includes("chat") ||
    kindReferencesMessage;

  return referencesReaction && referencesChatMessage;
};

const isBlockedPublicationNotification = (notification = {}) =>
  normalizeText(notification?.tipoNotificacion) === "publicacion bloqueada";

const isPublicationReportNotification = (notification = {}) =>
  normalizeText(notification?.tipoNotificacion) === "reporte de publicacion";

const isAttendanceNotification = (notification = {}) =>
  normalizeText(notification?.tipoNotificacion) === "asistencia";

const getNotificationProfileImage = (notification = {}) => {
  if (isBlockedPublicationNotification(notification)) {
    return "/img/icons/PRECAUCION.png";
  }

  if (
    isPublicationReportNotification(notification) ||
    isAttendanceNotification(notification)
  ) {
    return "/img/icons/UserFalse.svg";
  }

  return notification.fotoPerfilUrl ?? notification.fotoPerfilBase64;
};

const normalizeSeen = (value) => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }

  if (typeof value === "number") {
    return value === 1;
  }

  return false;
};

export const getNotificationsMapper = (notifications) => {
  let notificationsArray = []
  if (!Array.isArray(notifications)) {
    return notificationsArray;
  }

  notifications.forEach((notification) => {
    const notificationKind = notification?.tipoNotificacion ?? "";
    const isChatReaction = isChatReactionNotification(notification);
    const isBlockedPublication = isBlockedPublicationNotification(notification);
    const isAttendance = isAttendanceNotification(notification);
    const kind =
      notificationKind === "SolicitudAmistad" ||
      notificationKind === "FriendRequest" ||
      notificationKind === "Solicitud de amistad" ||
      notification?.mensaje?.includes?.("LB0727");
    notificationsArray.push({
      notificationId: notification?.idNotificacion,
      type: kind,
      notificationKind,
      isBlockedPublication,
      isAttendanceNotification: isAttendance,
      isChatReaction,
      title: notification?.titulo ?? "",
      nombreUsuario: isAttendance ? "" : notification?.nombres ?? "",
      seen: normalizeSeen(notification?.visto),
      userId: notification?.idUsuario,
      otherUserId: notification?.idPersona,
      redirectUserId: notification?.idPersona,
      content: notification?.mensaje,
      idPublicacion: notification?.idPublicacion,
      idMensaje: notification?.idMensaje ?? notification?.idMessage ?? null,
      idChat: notification?.idChat ?? notification?.IdChat ?? null,
      fotoPerfilBase64: getNotificationProfileImage(notification),

      timestamp:
        notification?.fechaRegistro ??
        notification?.fechaCreacion ??
        notification?.fechaEnvio ??
        notification?.fecha ??
        null,
    })
  })
  return notificationsArray
}
